export const APP_PATHS = {
  Auth: 'auth',
  Login: 'login',
  ResetPassword: 'reset-password',
  SetNewPassword: 'set-new-password',
  ResetPasswordSuccess: 'reset-password-success',
  SetNewPasswordSuccess: 'set-new-password-success',
  Dashboard: 'dashboard',
  Profile: 'profile',
  Partners: 'partners',
  PartnerDetail: 'partners/:partnerOid',
  PartnerLocationsCreate: 'partners/:partnerOid/locations/create',
  Partnerships: 'partnerships',
  PartnershipDetail: 'partnerships/:partnershipOid',
  InstallationGroups: 'installation-groups',
  InstallationGroupDetail: 'installation-groups/:installationGroupOid',
  Services: 'services',
  ServiceDetail: 'services/:serviceId',
  Installations: 'installations',
  MigrationReport: 'installations/migration-report',
  InstallationDetail: 'installations/:installationOid',
  Locations: 'locations',
  LocationDetail: 'locations/:locationId',
  Devices: 'devices',
  DeviceDetail: 'devices/:deviceId',
  DataExport: 'data-export',
  Settings: 'settings',
  Support: 'support',
  Documentation: 'documentation',
  Search: 'search',
  MyCompany: 'my-company',
  JoinNetwork: 'joinnetwork',
  LinkExpired: 'link-expired',
  User: 'user',
  WhiteLabel: 'partners/:partner_oid/whitelabel',
  Status: 'status',
  Alarms: 'alarms',
  FirmwareVersions: 'firmware/versions',
  FirmwareManagement: 'firmware-management',
  ComponentLibrary: 'dev/components',
};
